import { createFileRoute } from "@tanstack/react-router";
import { ActivityLogListFeature } from "@/features/activity-log-list/ActivityLogListFeature";

function ActivityPage() {
  return <ActivityLogListFeature />;
}

export const Route = createFileRoute("/activity/")({
  component: ActivityPage,
  staticData: { authorize: true },
});
